<nts-iframe
    [class.in-iframe]="inIframe"
    (loading)="iframeLoaded.next(true)"
    #iframe
    [url]="url">
</nts-iframe>